import Box from '@mui/material/Box/Box'
import Stack from '@mui/material/Stack/Stack'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography/Typography'

import { i18WithParams as t } from '@shared/locale'
import { WaitlistOrderClientDto } from 'service-api/src/types/api'

interface Props {
  order: WaitlistOrderClientDto
}

const status = {
  WAITLISTED: t('profile.waitlist.status.waitlisted'),
  CONTACTED: t('profile.waitlist.status.contacted'),
  CONVERTED: t('profile.waitlist.status.converted'),
  REMOVED: t('profile.waitlist.status.removed'),
}

const dotColor = {
  WAITLISTED: 'primary',
  CONTACTED: 'info',
  CONVERTED: 'success',
  REMOVED: 'error',
}

export const Status = ({ order }: Props) => {
  const theme = useTheme()

  // @ts-expect-error all is good, nothing to see
  const dot = dotColor[order.waitlistStatus] ?? 'primary'

  return (
    <Stack direction="row" alignItems="center" justifyContent="center" gap={1}>
      {/* @ts-expect-error all is good, nothing to see */}
      <Box height={8} width={8} sx={{ borderRadius: '50%', backgroundColor: theme.palette[dot]?.main }} />
      {/* @ts-expect-error all is good, nothing to see */}
      <Typography variant="body1">{status[order.waitlistStatus] || 'unknown'}</Typography>
    </Stack>
  )
}
